import { Navigate, Route, Routes } from "react-router-dom";
import Dashboard from "./components/dashboard";
import Layout from "./components/Layout";
import CustomerRecord from "./components/customerrecord";
import Appointments from "./components/appointments";
import Schedule from "./components/schedule";
import Order from "./components/order";
import Reporting from "./components/reporting";
import LoginPage from './components/auth/LoginPage';
import RequireAuth from './components/auth/RequireAuth';
import ProtectedRoute from './components/auth/ProtectedRoute';
import ForbiddenPage from './components/auth/ForbiddenPage';
import Inventory from "./components/admin/inventory";
import EmployeesPage from "./components/admin/EmployeesPage";
import LocationsPage from "./components/admin/LocationsPage";
import SecurityPage from "./components/admin/SecurityPage";
import MessagingPage from "./components/admin/MessagingPage";
import ValidDataPage from "./components/admin/ValidDataPage";
import AuditLogViewer from "./components/admin/audit/AuditLogViewer";
import EyeExamTemplatesPage from "./components/templates/EyeExamTemplatesPage";
import TaskListPage from "./components/task/TaskListPage";
import RecentActivityPage from "./components/activity/RecentActivityPage";
import TenantSettings from "./components/settings/TenantSettings";
import TimeTrackingPage from "./components/admin/time/TimeTrackingPage";

const routes = [
  {
    path: "dashboard",
    component: Dashboard,
    // Dashboard is accessible to all authenticated users
    permission: null
  },
  {
    path: "appointments",
    component: Appointments,
    permission: { section: 'scheduling', level: 'read' }
  },
  // { don't need this route for now
  //   path: "schedule",
  //   component: Schedule,
  //   permission: { section: 'scheduling', level: 'read' }
  // },
  {
    path: 'customerrecord',
    component: CustomerRecord,
    permission: { section: 'customers', level: 'read' }
  },
  // Legacy dynamic variant (backward compatibility for old links like /customerrecord/123)
  {
    path: 'customerrecord/:customerId',
    component: CustomerRecord,
    permission: { section: 'customers', level: 'read' }
  },
  // Dynamic customer record route to open a specific customer
  {
    path: 'customers/:customerId',
    component: CustomerRecord,
    permission: { section: 'customers', level: 'read' }
  },
  {
    path: 'inventory',
    component: Inventory,
    permission: [
      { section: 'inventory', level: 'read' },
      // we don't need admin read for inventory access
      //{ section: 'admin', level: 'read' }
    ]
  },
  {
    path: 'reporting',
    component: Reporting,
    permission: { section: 'reporting', level: 'read' }
  },
  {
    path: 'templates',
    component: EyeExamTemplatesPage,
    permission: { section: 'eyeexam', action: 'manage-templates' }
  },
  {
    path: 'order',
    component: Order,
    permission: { section: 'inventory', level: 'write' }
  },
  // Admin section routes - separated for granular permissions
  {
    path: 'employees',
    component: EmployeesPage,
    permission: { section: 'employees', level: 'read' }
  },
  {
    path: 'locations',
    component: LocationsPage,
    permission: { section: 'locations', level: 'read' }
  },
  {
    path: 'security',
    component: SecurityPage,
    permission: { section: 'security', level: 'read' }
  },
  {
    path: 'audit',
    component: AuditLogViewer,
    permission: { section: 'audit', level: 'read' }
  },
  {
    path: 'messaging',
    component: MessagingPage,
    permission: { section: 'messaging', level: 'read' }
  },
  {
    path: 'validdata',
    component: ValidDataPage,
    permission: { section: 'admin', level: 'read' }
  },
  {
    path: 'tasks',
    component: TaskListPage,
    permission: null // Accessible to all authenticated users
  },
  {
    path: 'activity',
    component: RecentActivityPage,
    permission: null // Accessible to all authenticated users
  },
  {
    path: 'time-tracking',
    component: TimeTrackingPage,
    permission: { section: 'employees', action: 'time-tracking' }
  },
  {
    path: 'settings',
    component: TenantSettings,
    permission: { section: 'settings', level: 'read' }
  },
  // Keep legacy admin route for backward compatibility
  // {
  //   path: 'admin',
  //   component: Admin,
  //   permission: { section: 'admin', level: 'read' }
  // }
];

// Export routes for use in other components (navigation filtering, etc.)
export { routes };

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forbidden" element={<ForbiddenPage />} />
      <Route path="/" element={<RequireAuth><Layout /></RequireAuth>}>
        {routes.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={
              <ProtectedRoute requiredPermission={route.permission}>
                <route.component />
              </ProtectedRoute>
            }
          />
        ))}
      </Route>
    </Routes>
  );
}

// <Routes>
//   {routes.map((route, index) => (
//     <Route
//       key={index}
//       path={route.path}
//       element={<route.component />}
//       //    render={(props) => withAppbar(route.component, props)}
//     />
//   ))}
// </Routes>;
